import { Box, Card, Chip, ChipOwnProps, Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  statusChipProps: ChipOwnProps;
  label: ReactNode;
  tag?: string;
}

export const SettingsFormStatus: FC<Props> = ({ statusChipProps, label, tag }) => {
  return (
    <Card variant="outlined">
      <Box sx={{ p: 1.5, flex: 1, justifyContent: 'space-between', display: 'flex' }}>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
          <Chip {...statusChipProps} sx={{ borderRadius: 1, width: '100px' }} />
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {label}
          </Typography>
        </Stack>
        {tag && <Chip label={tag} color="default" sx={{ borderRadius: 1 }} />}
      </Box>
    </Card>
  );
};
